export const SITE_URL = "https://intersect.com.sa";
export const SITE_NAME = "Intersect Holding";
export const DEFAULT_DESC =
  "Intersect Holding is a Saudi investment and strategic holding company building ventures, creating partnerships and connecting capital with opportunity across Saudi Arabia and global markets.";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

// Route-based metadata for static pages. Keys are exact pathnames.
export const ROUTE_META = {
  "/": {
    title: "Intersect Holding — Where Capital, Opportunity & Partnerships Intersect",
    description: DEFAULT_DESC,
  },
  "/about": {
    title: "About — Intersect Holding",
    description:
      "A Saudi investment and strategic holding company. Intersect develops ventures, partnerships and long-term commercial relationships across Saudi Arabia and international markets.",
  },
  "/investment": {
    title: "Investment — Intersect Holding",
    description:
      "Backing businesses with more than capital: strategic capital paired with Saudi market access, relationships and the ability to execute across early, growth and strategic stages.",
  },
  "/partnerships": {
    title: "Partnerships — Intersect Holding",
    description:
      "Intersect brings together organizations with complementary capabilities to create strategic alliances, joint ventures and commercial partnerships connecting global capability with Saudi opportunity.",
  },
  "/saudi-arabia": {
    title: "Saudi Arabia — Intersect Holding",
    description:
      "Saudi Arabia is becoming a platform for global growth. Explore how Intersect identifies investment, partnership and venture-building opportunities across the Kingdom's economic transformation.",
  },
  "/portfolio": {
    title: "Portfolio & Ventures — Intersect Holding",
    description:
      "Investments, ventures, partnerships and joint ventures developed by Intersect Holding across Saudi Arabia and international markets.",
  },
  "/insights": {
    title: "Insights — Intersect Holding",
    description:
      "Perspectives from Intersect on capital, partnerships, markets and the Saudi economy.",
  },
  "/contact": {
    title: "Contact — Intersect Holding",
    description:
      "Start a conversation with Intersect Holding. Whether you are seeking investment, exploring Saudi Arabia or looking for a partner, we would like to hear from you.",
  },
  "/opportunity": {
    title: "Present an Opportunity — Intersect Holding",
    description:
      "Share your company, venture or partnership opportunity with Intersect Holding. Submissions are stored securely and reviewed by our team.",
  },
  "/privacy": {
    title: "Privacy Policy — Intersect Holding",
    description: "How Intersect Holding collects, stores and processes your information.",
  },
  "/terms": {
    title: "Terms of Use — Intersect Holding",
    description: "The terms governing use of the Intersect Holding website.",
  },
  "/cookies": {
    title: "Cookie Policy — Intersect Holding",
    description: "How Intersect Holding uses cookies and similar technologies.",
  },
};

export function metaForPath(pathname) {
  if (ROUTE_META[pathname]) return ROUTE_META[pathname];
  if (pathname.startsWith("/portfolio/"))
    return { title: "Venture — Intersect Holding", description: ROUTE_META["/portfolio"].description };
  if (pathname.startsWith("/insights/"))
    return { title: "Insight — Intersect Holding", description: ROUTE_META["/insights"].description };
  return {
    title: "Page Not Found — Intersect Holding",
    description: DEFAULT_DESC,
    noindex: true,
  };
}
